module.exports = __webpack_public_path__ + "static/media/lying.bf5e7401.svg";